import cloneDeep from "lodash/cloneDeep";
import { type TestCaseTItem, rootTestCaseTItem } from "../../core";
import { tCasesAssertChildTitleUniq } from "../assertChildTitleUniq";
import { tCasesAssertIdUniq } from "../assertIdUniq";
import { tCasesPredicateFind } from "../predicateFind";
import { tCasesSort } from "../sort";

export type TCasesAddArg = {
  rootTreeItem: TestCaseTItem;
  idToAddTo: TestCaseTItem["id"];
  itemToAdd: TestCaseTItem;
};
export type TCasesAddRtrn = TCasesAddArg["rootTreeItem"];

export const tCasesAdd = ({ idToAddTo, itemToAdd, rootTreeItem }: TCasesAddArg): TCasesAddRtrn => {
  if (tCasesAssertIdUniq({ root: rootTreeItem, id: itemToAdd.id }) === false) return rootTreeItem;

  const cloned = cloneDeep(rootTreeItem);
  const clonedMaybeItemToAddTo = tCasesPredicateFind({ rootTreeItem: cloned, predicate: (it) => it.id === idToAddTo });
  if (clonedMaybeItemToAddTo === null || clonedMaybeItemToAddTo.type !== "folder") return rootTreeItem;

  if (
    tCasesAssertChildTitleUniq({ root: cloned, parentId: clonedMaybeItemToAddTo.id, title: itemToAdd.title }) === false
  ) {
    return rootTreeItem;
  }

  const clonedNextChildren = clonedMaybeItemToAddTo.children.concat(itemToAdd);
  const withSortedChildren = tCasesSort({ ...rootTestCaseTItem, children: clonedNextChildren });

  // this is 100% true, but just for types
  if (withSortedChildren.type === "folder") {
    clonedMaybeItemToAddTo.children = withSortedChildren.children;
  }

  return cloned;
};
